import React from 'react';
import { useEffect, useState, useCallback } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import Menu from './Menu';
import { NavDropdown } from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
import { useModal } from '../contexts/ModalContext';

export default function Header() {
  const [isSticky, setIsSticky] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const { openQueryModal } = useModal();
  const handleToggleMenu = useCallback(() => setIsOpen((prev) => !prev), []);
  const navigate = useNavigate();
  const [dropdownOpen1, setDropdownOpen1] = useState(false);
  const [dropdownOpen2, setDropdownOpen2] = useState(false);
 

  const handleScroll = useCallback(() => {
    const heightFromTop = window.scrollY;
    setIsSticky(heightFromTop > 0);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  // const handleLogoClick = () => {
  //   navigate("/");
  // };

  return (
    <>
      <header className={`header-area ${isSticky ? 'stick' : ''}`}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-3 col-6 col-md-3">
              {/* <div className="logo" onClick={handleLogoClick}>
                <iframe src="https://lottie.host/embed/82975dbe-fdea-4c1f-9c0c-bad947b415c9/lm8NcYpGej.lottie"></iframe>
              </div> */}
              <div className="logo">
                <Link to={"/"}><img src="/assets/images/logo.gif" alt="Logo" /></Link>
              </div>
            </div>

            <div className="col-lg-6 col-5 col-md-6 mobile-tab-hide">
              <div className="menuright">
                <ul className="main-menu">
                  <li className={`nav-item dropdown has-dropdown ${dropdownOpen2 ? "show" : ""}`} onMouseEnter={() => setDropdownOpen2(true)} onMouseLeave={() => setDropdownOpen2(false)}>
                    <Link to="/services/">Services <i className="fa-solid fa-angle-down"></i></Link>
                    <ul className={`dropdown-menu ${dropdownOpen2 ? "show" : ""}`}>
                      <li><Link to="/interior-design-build/">Interior Design</Link></li>
                      <li><Link to="/turnkey-interior-design-services/">Turnkey Execution</Link></li>
                      <li><Link to="/top-property-management-services/">Property management Service</Link></li>
                    </ul>
                  </li>

                  <li><Link to="/projects/">Projects</Link></li>

                  <li className={`nav-item dropdown has-dropdown ${dropdownOpen1 ? "show" : ""}`} onMouseEnter={() => setDropdownOpen1(true)} onMouseLeave={() => setDropdownOpen1(false)}>
                    <Link to="/our-story/">About <i className="fa-solid fa-angle-down"></i></Link>
                    <ul className={`dropdown-menu ${dropdownOpen1 ? "show" : ""}`}>
                      <li><Link to="/our-story/">our Story</Link></li>
                      <li><Link to="/our-clients/">Our Clients</Link></li>
                      <li><Link to="/careers/">Careers</Link></li>
                      <li><Link to="/testimonial/">Testimonial</Link></li>
                      <li><Link to="/partner-with-us/">Partner With Native Sutra</Link></li>
                    </ul>
                  </li>

                  <li><Link to="/blog/">Blogs</Link></li>
                </ul>
              </div>
            </div>

            <div className="col-lg-3 col-6 col-md-3">
                <div className="menucontact">
                  <ul className="main-menu">   
                    <li><Link to="/contact-us/">Contact</Link></li>  
                  </ul>
                  <div className='openmenu-butn' onClick={handleToggleMenu}>menu</div>
                </div>
                <Link onClick={openQueryModal} className='openmenu-butn landpage-menulink'>consult Now</Link>
              </div>
          </div>
        </div>
      </header>

      <Menu isOpen={isOpen} setIsOpen={setIsOpen}/>
    </>
  )
}